// extracted by mini-css-extract-plugin
module.exports = {"documentSectionTitle":"DocumentsSection_documentSectionTitle__1QwST","date":"DocumentsSection_date__17ENN"};